import { memo } from 'react'
import { useIntl } from 'react-intl'

import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OfferPagePackageInclusionsList from 'components/OfferPage/OfferPagePackageInclusionsList'
import Group from 'components/utils/Group'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'

interface Props {
  property: App.Property.Property
  inclusions: Array<App.OfferInclusion>
  bonusInclusions: Array<App.OfferInclusion>
  luxPlusInclusions: Array<App.OfferInclusion>
  bundleInclusions: Array<App.OfferInclusion>
  maxHeight: number
}

function PropertyRateInclusions({
  property,
  inclusions,
  bonusInclusions,
  luxPlusInclusions,
  bundleInclusions,
  maxHeight,
}: Props) {
  const intl = useIntl()

  return <LargeContentToggle
    maxHeight={maxHeight}
    showMoreText={intl.formatMessage({
      id: '74uMot_LhpmF_fW845tr',
      defaultMessage: 'View more inclusions',
      description: 'Toggle text to expand inclusions list for property rate option',
    })}
    showLessText={intl.formatMessage({
      id: 'i_MD93nsLRPDKVjXbxqE',
      defaultMessage: 'View less inclusions',
      description: 'Toggle text to collapse inclusions list for property rate option',
    })}
  >
    <VerticalSpacer gap={12}>
      {!!luxPlusInclusions.length && <LuxPlusInclusions
        luxPlusInclusions={luxPlusInclusions}
        accommodationOffer={property}
      />}
      {!!bonusInclusions.length && <OfferPagePackageInclusionsList variant="bonus">
        {bonusInclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
      </OfferPagePackageInclusionsList>}
      <Group direction="vertical" gap={4} noDisplayWhenEmpty>
        {!!bundleInclusions.length && <VerticalSpacer gap={4}>
          {bundleInclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted colour="exclusive" />)}
        </VerticalSpacer>}
        {!!inclusions.length && <VerticalSpacer gap={4}>
          {inclusions.map(inclusion => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
        </VerticalSpacer>}
        <LoyaltyInclusions offer={property} variant="offer-page" />
      </Group>
    </VerticalSpacer>
  </LargeContentToggle>
}

export default memo(PropertyRateInclusions)
